import GradePage from "@/pages/GradePage";
export default function GradeGrade2() {
  return <GradePage grade="2" />;
}
